<template>
  <div class="yc-body-main-wrapper full-height overflow-x-hidden" v-resize="onResize">
    <div class="d-flex" v-if="!focusContent">
      <div v-if="hiddenMenu && windowSize.x >= 1280">
        <div class="fullscreen fill-height table-of-contents overflow-x-hidden overflow-y-auto">
          <h2 class="txt-title text-uppercase pa-0 py-2 text-center">{{ $t('USER_GUIDE.TABLE_OF_CONTENT') }}</h2>
          <section
              class="content pr-3"
              id="table-of-content">
          </section>
        </div>
      </div>
      <div>
        <div class="yc-container">
          <div class="yc-content overflow-x-hidden" id="scroll-content" ref="sectionForm" @scroll="onScroll"
               :style="{
                     width:windowSize.x >= 1280 ? windowSize.x - 524 + 'px' : windowSize.x + 'px',
                     left: windowSize.x >= 1280 ? '520px' : 0,
                     position: windowSize.x >= 1280 ? 'fixed' : 'absolute',
                     height: 'calc(100vh - 56px)'
                    }"
          >
            <div class="px-6">
              <div
                   :class="{
                    'mx-auto': windowSize.x <= 1280
                  }"
              >
                <div id="content">
                  <VueMarkdown
                      id="scrollTabsContainer"
                      class="scrollTabsContainer"
                      :source="someMarkdownText"
                      :toc="true"
                      :watches="sources"
                      :toc-first-level="1"
                      :toc-last-level="7"
                      :toc-anchor-link-symbol="''"
                      :toc-anchor-link-class="'v-list-active'"
                      @rendered="rendered"
                      :prerender="prerender"
                      :postrender="postrender"
                      toc-id="table-of-content"
                  ></VueMarkdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mx-auto d-flex" v-else>
      <v-card
          elevation="2"
          class="mx-auto my-12 pa-10"
          max-width="1100"
      >
        <VueMarkdown
            id="scrollTabsContainer1"
            class="scrollTabsContainer text-left"
            :source="someMarkdownText"
            :toc="true"
            :watches="sources"
            :toc-first-level="1"
            :toc-last-level="6"
            :toc-anchor-link-symbol="''"
            :toc-anchor-link-class="'v-list-active'"
            @rendered="rendered"
            :prerender="prerender"
            :postrender="postrender"
            toc-id="table-of-content"
        ></VueMarkdown>

      </v-card>
    </div>
  </div>
</template>

<script>
import Vue from "vue"
import VueMarkdown from 'vue-markdown'
import MSuiteUserGuide from '@/views/user-guide/M-Suite-UserPortalandAgent-Guide.md';

export default Vue.extend({
  name: "UserGuide",
  components: {
    VueMarkdown,
  },
  data() {
    return {
      windowSize: {
        x: 0,
        y: 0,
      },
      loadingComplete: false,
      hiddenMenu: true,
      focusContent: false,
      menus: [],
      contents: [],
      sources: ["source", "show", "toc"],
      someMarkdownText: '',
      sectionObserver: null,
      numberResult: 0,
      currentResult: 0,
      lastScrollTime: null,
      currentContent: "",
    }
  },

  watch: {
    "$route": {
      async handler(router) {
        if (this.loadingComplete) {
          this.currentContent = this.getContentFromHash(router.hash);
          await this.activeMenu(this.currentContent, false, true)
        }
        this.$nextTick(() => {
          this.focusContent = !!(router && router.query && router.query.focusContent)
        })
      },
      deep: true,
      immediate: true
    },
    currentContent: {
      async handler(val) {
        if (this.loadingComplete) {
          await this.activeMenu(val, false, true)
        }
      },
      immediate: true
    }
  },

  created() {
    const vm = this
    this.$nextTick(async () => {
      await vm.onResize()
      await vm.renderHtml()
      if (vm.$route && vm.$route.hash) {
        await vm.activeMenu(vm.getContentFromHash(vm.$route.hash), true)
      }
      vm.loadingComplete = true
    })
  },

  methods: {
    onResize() {
      this.windowSize = {
        x: window.innerWidth,
        y: window.innerHeight
      }
    },

    renderHtml() {
      this.someMarkdownText = MSuiteUserGuide
    },

    onScroll() {
      const now = Date.now();
      if (now - this.lastScrollTime < 300) {
        return
      }
      this.lastScrollTime = now;
      const elements = document.querySelectorAll("#scroll-content h2, h3, h4, h5, h6")
      const listElmOffset = Array.from(elements).map(el => Math.abs(el.getBoundingClientRect().top - 56));
      const indexOfMin = listElmOffset.indexOf(Math.min(...listElmOffset));
      let current = elements[indexOfMin].getAttribute("id");
      if (current) {
        this.currentContent = current;
        this.onScrollTableOfContent(current)
      }
    },

    async activeMenu(currentContent, mount = false, changeUrl = false) {
      this.$nextTick(() => {
        const tableOfContent = document.querySelectorAll("section ul li a");
        tableOfContent.forEach(anchorElm => {
          anchorElm.classList.remove('active')
          const elmID = this.getContentFromHash(anchorElm.getAttribute('href'));
          if (currentContent === elmID) {
            anchorElm.classList.add('active')
            if (currentContent) {
              setTimeout(() => {
                const element = document.getElementById(elmID)
                const offsetTop = element.offsetTop
                const content = document.getElementById("scroll-content")
                if (!changeUrl) {
                  if (!mount) {
                    if (offsetTop && content) {
                      content.scroll({
                        top: offsetTop,
                        behavior: 'smooth',
                      })
                    }
                  } else {
                    this.onScrollTableOfContent(anchorElm.getAttribute('href'))
                    content.scroll({
                      top: element.offsetTop,
                    })
                  }
                }
              }, 250)
            }
          }
        });
      })
    },

    getContentFromHash(hash) {
      return decodeURIComponent(hash).replace('#', '');
    },

    onScrollTableOfContent(content) {
      const listEl = document.querySelectorAll('#table-of-content ul li a')
      for (const el of listEl) {
        const elContent = this.getContentFromHash(el.getAttribute('href'))
        if (elContent === content) {
          el.scrollIntoView({block: "center", inline: "nearest"})
          break;
        }
      }
    },

    rendered(html) {
      const htmlObject = document.createElement('div');
      htmlObject.innerHTML = html;
    },

    prerender(html) {
      return html;
    },

    postrender(html) {
      if (!this.focusContent) {
        return html
      }
      const hash = this.$route.hash
      let hashToString = decodeURIComponent(hash)
      const htmlObject = document.createElement('div');
      htmlObject.innerHTML = html;
      const childrenEls = htmlObject.children;
      let stringElement = ''

      if (hashToString) {
        hashToString = hashToString.replace('#', '')
      }
      let oldKey = ''
      for (const childrenEl of childrenEls) {

        if (childrenEl.id && childrenEl.id === hashToString) {
          oldKey = childrenEl.id
          stringElement += childrenEl.outerHTML
        }

        if (childrenEl.id) {
          oldKey = childrenEl.id
        }

        if (!childrenEl.id && oldKey === hashToString) {
          stringElement += childrenEl.outerHTML
        }
      }
      if (!stringElement) {
        return html
      }
      return stringElement;
    },

    goToContact() {
      this.$router.push({path: '/user-guide/contact'})
    },

    goToTroubleShootingPage() {
      const baseUrl = sessionStorage.getItem('serverName') || localStorage.getItem('serverName') || 'msuite.viettel.vn';
      const url = '/help#3-t%C3%A0i-li%E1%BB%87u-h%C6%B0%E1%BB%9Bng-d%E1%BA%ABn-fix-l%E1%BB%97i-cho-agent';
      window.open('https://' + baseUrl + url, '_blank');
    }
  },
})
</script>

<style lang="scss">
.text-warning {
  font-weight: bold !important;
}

#scrollTabsContainer {
  img {
    max-width: 100%;
  }

  h1, h2, h3, h4 {
    font-size: 24px;
    margin-bottom: 24px;
  }

  h5, h6 {
    font-size: 16px;
    margin-bottom: 24px;
  }
}
#scrollTabsContainer1 {
  img {
    max-width: 100%;
    margin-bottom: 24px;
    margin-top: 24px;
  }

  h1, h2, h3, h4 {
    font-size: 24px!important;
    margin-bottom: 24px;
  }

  h5, h6 {
    font-size: 16px;
    margin-bottom: 24px;
  }
}

.table {
  padding: 20px;
  border: 1px solid black;
  border-collapse: collapse;

  th, td {
    padding: 20px;
    border: 1px solid black;
    border-collapse: collapse;
  }
}

.dialog-new-version {
  position: absolute;
  top: 50px;
  left: 515px;
  overflow-y: inherit;
}

.new-version-tooltip {
  background-color: #303036;
  border-radius: 4px;
  width: 236px;
  height: 186px;
  padding: 16px 16px 16px 24px;
  position: relative;

  .triangle-draw {
    width: 8px;
    height: 8px;
    background-color: #303036;
    position: absolute;
    top: 16px;
    left: -4px;
    transform: rotate(45deg);
  }

  .tooltip-title {
    display: flex;
    justify-content: space-between;
    color: #F2F2F3;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
  }

  .divider {
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
    margin: 6px 0 12px;
  }

  .tooltip-content {
    color: #C9C9CF;
    font-size: 14px;
    margin-bottom: 16px;
  }
}
</style>
